export default __webpack_public_path__ + "static/media/dust-wallet.13a26f39.png";